import { render, staticRenderFns } from "./PaymentQuotaDetail.vue?vue&type=template&id=5cad4baa"
import script from "./PaymentQuotaDetail.vue?vue&type=script&lang=js"
export * from "./PaymentQuotaDetail.vue?vue&type=script&lang=js"
import style0 from "./PaymentQuotaDetail.vue?vue&type=style&index=0&id=5cad4baa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports